import React from "react";
import "../styles/Footer.css";
import { FaTwitter } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* Company Section */}
        <div className="footer-section company-section">
          <div className="logo">
            <img src="/images/Skill_Master.png" alt="Skill Master Logo" className="logo-img" />
            SKILL<span>MASTER</span>
          </div>
          <div className="company-address">
            <p>C-05, Kailash Dham, Dongre Park, Chembur,</p>
            <p>Mumbai – 400074</p>
          </div>
          <div className="company-contact">
            <p>+91 9890906048</p>
            <p>isfedutech@gmail.com</p>
            <p>info@isfinformatica.com</p>
          </div>
          <div className="social-links">
            <a href="https://www.facebook.com/isfedutech" className="social-link facebook">f</a>
            <a href="https://www.twitter.com/isfedutech" className="social-link twitter" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
            <a href="https://www.linkedin.com/company/isf-edutech" className="social-link linkedin">in</a>
            <a href="https://medium.com/@isfedutech" className="social-link medium">M</a>
            <a href="https://in.pinterest.com/isfedutech" className="social-link pinterest">P</a>
            <a href="https://www.quora.com/profile/ISF-Edutech" className="social-link quora">Q</a>
            <a href="https://www.youtube.com/channel/UC5-S1eiLCQm7yT10hmuAKNQ?view_as=subscriber" className="social-link youtube">▶</a>
          </div>
        </div>

        {/* Our Company */}
        <div className="footer-section">
          <h4 className="footer-title">Our Company</h4>
          <ul className="footer-menu-links">
            <li><a href="#" className="footer-menu-link">About Us</a></li>
            <li><a href="#" className="footer-menu-link">Contact Us</a></li>
            <li><a href="/#/privacy_policy" className="footer-menu-link">Privacy Policy</a></li>
          </ul>
        </div>

        {/* Dashboard */}          
        <div className="mobile-app-section">
            <h5 className="app-title">Download Mobile App</h5>
            <div className="app-buttons">
                <a href="#" className="app-btn">
                <div className="play-icon">▶</div>
                <div className="app-text">
                    <span className="get-text">Get it on</span>
                    <span className="store-text">Google Play</span>
                </div>
                </a>
            </div>
            
            <h5 className="app-title">Download TV App / Fire Stick / Set-Top Box</h5>
            <div className="app-buttons">
                <a href="#" className="app-btn">
                <div className="play-icon">▶</div>
                <div className="app-text">
                    <span className="get-text">Get it on</span>
                    <span className="store-text">Google Play</span>
                </div>
                </a>
            </div>
            </div>
        </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <div className="copyright-section">
            <p className="copyright">
              Easylearn Copyright © 2021 | All Rights Reserved with ISF Analytica & Informatica Pvt. Ltd.
            </p>
          </div>
          
          <div className="powered-section">
            <div className="powered-item">
              <p className="powered-title">Powered By :</p>
              <div className="partner-logo">
                <div className="logo-circle"></div>
                <span className="partner-text"><span className="analytica"> ISF ANALYTICA & INFORMATICA</span></span>
              </div>
            </div>
            
            <div className="powered-item">
              <p className="powered-title">Consulting and Solutioning Partner :</p>
              <div className="partner-logo">
                <div className="logo-circle"></div>
                <span className="partner-text"> <span className="edutech">ISF EduTech</span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;